/* eslint-disable prettier/prettier */
import pointsServices from 'src/services/pointsServices'
import { pointConstantS } from '../constants/pointConstants'

export const levelPointAction = (header) => (dispatch) => {
  pointsServices
    .levelPoint(header)
    .then((data) => {
      dispatch({
        type: pointConstantS.FETCHING_LEVEL_POINT_API_SUCCESS,
        payload: data.data,
      })
    })
    .catch((err) => {
      dispatch({
        type: pointConstantS.FETCHING_LEVEL_POINT_API_FAILED,
        payload: err.message,
      })
    })
}
export const rewardPointAction = (header) => (dispatch) => {
  pointsServices
    .rewardPoint(header)
    .then((data) => {
      dispatch({
        type: pointConstantS.FETCHING_REWARD_POINT_API_SUCCESS,
        payload: data.data,
      })
    })
    .catch((err) => {
      dispatch({
        type: pointConstantS.FETCHING_REWARD_POINT_API_FAILED,
        payload: err.message,
      })
    })
}
export const taskPointAction = (header) => (dispatch) => {
  pointsServices
    .taskPoint(header)
    .then((data) => {
      dispatch({
        type: pointConstantS.FETCHING_TASK_POINT_API_SUCCESS,
        payload: data.data,
      })
    })
    .catch((err) => {
      dispatch({
        type: pointConstantS.FETCHING_TASK_POINT_API_FAILED,
        payload: err.message,
      })
    })
}
